import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan interval switch: the annual segment's label.
export default class AnnualText extends BaseOption {
  static userInterfaceComponent = {
    label: "Annual Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Annual";
}
